import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../../../common/template/content';
import ContentCard from '../../../common/template/contentCard';
import ContentCardHeader from '../../../common/template/contentCardHeader';
import ContentCardBody from '../../../common/template/contentCardBody';
import ContentCardFooter from '../../../common/template/contentCardFooter';
import Row from '../../../common/layout/row';
import Grid from '../../../common/layout/grid';
import Button from '../../../common/button/button';
import Form from '../../../common/form/form';
import LabelAndInput from '../../../common/form/labelAndInput';
import Select from '../../../common/form/select';
import LabelAndInputNumber from '../../../common/form/labelAndInputNumber';
import LabelAndCheckbox from '../../../common/form/labelAndCheckbox';

import { setModoTela, initForm } from './produtoModeloActions';

class ProdutoModeloForm extends Component {

    componentWillMount() {

	}

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='id_produto'
								component={Select}
								options={this.props.listaProduto}
								label='Produto *' placeholder='Informe o produto'
								cols='12 12 12 12'
								readOnly={readOnly} />
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Adicionar Produto'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

ProdutoModeloForm = reduxForm({form: 'produtoModeloForm', destroyOnUnmount: false})(ProdutoModeloForm);
const mapStateToProps = state => ({
	sessao: state.auth.produtoModelo,
	formularioValues: getFormValues('produtoModeloForm')(state),
	registro: state.produtoModelo.registro,
	listaProduto: state.produtoCategoriaModelo.listaProduto
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ProdutoModeloForm);
